import React from 'react'
import GitHubIcon from '@mui/icons-material/GitHub';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import './project.css'
const OtherProjects = ({ project }) => {
    return (
        <div className="project-cardd">
            <h3 className="project-title">{project.title}</h3>
            <div style={{
                display: 'flex',
                flexWrap: "wrap"
            }}>
                {
                    project.tech.map((t) => <span className="tech">{t}</span>)
                }
            </div>
            <p className="project-description">{project.description}</p>
            <div className={`link`}>
                <a href={project.github} target='_blank'><GitHubIcon sx={{ color: 'white' }} /></a>
                {project.link && <a href={project.link} target='_blank'><OpenInNewIcon sx={{ color: 'white' }} /></a>}
            </div>
        </div>
    );
}

export default OtherProjects
